import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Fiber from "./pages/Fiber";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

export interface INavigation {
  id: string;
  name: string;
  href: string;
  categories: number[];
  active?: boolean;
}

export const Navigations: INavigation[] = [
  { id: "home", name: "Home", href: "/", categories: [0] },
  { id: "aboutus", name: "ABOUTUS", href: "/aboutus", categories: [0] },
  { id: "fiber", name: "FIBER", href: "/fiber", categories: [0] },
  { id: "contact", name: "CONTACT", href: "/contact", categories: [0] },
];

const AppRoutes: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/fiber" element={<Fiber />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
